import PaginatedResponse from '../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { ArcTeamDto } from './model.dto'

@ObjectType()
export class ArcTeamPagedResultDto extends PaginatedResponse(ArcTeamDto) {
}
